// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_hVe","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_aKs FallbackBulkDownloadUpsellModalControl-cls1_hVe"};